"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _input = _interopRequireDefault(require("../../../../styles-common/input"));

var _isFloat = _interopRequireDefault(require("@widget-editor/shared/lib/helpers/isFloat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var StyledInput = (0, _styledComponents["default"])(_input["default"]).withConfig({
  displayName: "component__StyledInput",
  componentId: "sc-4recye-0"
})(["text-align:left !important;"]);

var getInputValue = function getInputValue(type, value) {
  if (value === null || value === undefined) {
    return '';
  }

  if (type === 'number') {
    return +value;
  }

  if (type === 'date') {
    return new Date(value).toISOString().split('T')[0];
  }

  return value;
};

var FilterValue = function FilterValue(_ref) {
  var filter = _ref.filter,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["filter", "onChange"]);

  var _ref2 = (0, _react.useState)(getInputValue(filter.type, filter.value)),
      _ref3 = _slicedToArray(_ref2, 2),
      value = _ref3[0],
      setValue = _ref3[1];

  var isFloatingPoint = filter.type === 'number' && ((0, _isFloat["default"])(filter.config.min) || (0, _isFloat["default"])(filter.config.max));
  var onChangeDebounced = (0, _react.useCallback)((0, _debounce["default"])(onChange, 500), [onChange]);
  var onChangeValue = (0, _react.useCallback)(function (_ref4) {
    var target = _ref4.target;
    var newValue = target.value;

    if (filter.type === 'number') {
      newValue = +target.value;
    } else if (filter.type === 'date') {
      newValue = new Date(target.value);
    }

    setValue(getInputValue(filter.type, newValue));
    onChangeDebounced(newValue);
  }, [filter, onChangeDebounced]);
  return _react["default"].createElement(StyledInput, _extends({
    type: filter.type === 'string' ? 'text' : filter.type,
    name: "filter-value-".concat(filter.id)
  }, filter.type === 'number' ? {
    step: isFloatingPoint ? 0.1 : 1,
    min: Math.floor(filter.config.min),
    max: Math.ceil(filter.config.max)
  } : {}, filter.type === 'date' ? {
    min: getInputValue('date', filter.config.min),
    max: getInputValue('date', filter.config.max)
  } : {}, {
    value: value,
    onChange: onChangeValue
  }, rest));
};

FilterValue.propTypes = {
  filter: _propTypes["default"].shape({
    column: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].string.isRequired,
    operation: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].any, _propTypes["default"].arrayOf(_propTypes["default"].any)]),
    config: _propTypes["default"].object.isRequired
  }).isRequired,
  onChange: _propTypes["default"].func.isRequired
};
var _default = FilterValue;
exports["default"] = _default;